import {
	AssessmentComponent,
	AssessmentStateEntry,
	ComponentVersion,
	DeviceType,
	graderComponents,
} from "@pandas/assessment-engine";
import { FlowHelpers, FlowType } from "@/lib/flow-logic/flowTypeHelpers";
import { useLocalStorageStore } from "@/store";
import { GetAssessmentEngineSingleton } from "./assessmentEngineSingleton";

export default async function initAssessmentEngine(
	flow: FlowType,
	configFunctionalAssessments: Array<AssessmentComponent>,
	existingResultsForIMEI: Array<AssessmentStateEntry>,
	graderResults: Array<AssessmentStateEntry>,
	componentVersion: ComponentVersion,
) {
	const deviceType = useLocalStorageStore.getState().deviceInfo.deviceType;
	const engineState = useLocalStorageStore.getState().assessmentEngineState;
	const setAssessmentEngineState = useLocalStorageStore.getState().setAssessmentEngineState;
	let graderAssessments: Array<AssessmentComponent> = [];
	if (FlowHelpers.isCosmeticFirst(flow)) graderAssessments = [...graderComponents];

	const allComponents = [...configFunctionalAssessments, ...graderAssessments];

	const filteredFunctionalResults = existingResultsForIMEI.filter((item) => allComponents.includes(item.assessmentKey));
	const filteredEngineState = engineState.filter((item) => allComponents.includes(item.assessmentKey));

	const engine = await GetAssessmentEngineSingleton(deviceType as DeviceType, allComponents, componentVersion);

	const allResults = [...filteredFunctionalResults, ...filteredEngineState, ...graderResults];
	engine.ImportAndAttachToState(allResults, setAssessmentEngineState);

	return engine;
}
